import { WebSocketReceiveMessage } from './web-socket-receive-message';

export type DeletedBrandAttributeGroup = { brandAttributeGroupId: string; id: string };

export class WebSocketBrandAttributeGroupsDeleted extends WebSocketReceiveMessage {
  override payload: DeletedBrandAttributeGroup[];

  override onDeserialize() {
    super.onDeserialize();
    const incoming: any[] = Array.isArray(this.payload) ? this.payload : [this.payload];
    this.payload = incoming.filter(Boolean);
  }
}
